/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import { CONTAINER_FORM, CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE, CONTAINER_REGISTRATION_SUCCEED } from 'Constant';
import { CLASSNAME_HIDDEN } from '@vfde-brix/core';
import { showServiceNotAvailableNotification, showSuccessNotification } from './renderNotification';

/**
 * Export initialFormView
 *
 * @export initialFormView
 */
 export const initialFormView = () => {
    const containerForm = document.getElementById(CONTAINER_FORM) as HTMLElement;
    const containerRegistrationSucceed = document.getElementById(CONTAINER_REGISTRATION_SUCCEED) as HTMLElement;
    const containerServiceNotAvailable = document.getElementById(CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE) as HTMLElement;

    containerForm.classList.toggle(CLASSNAME_HIDDEN, false);
    containerRegistrationSucceed.classList.toggle(CLASSNAME_HIDDEN, true);
    containerServiceNotAvailable.classList.toggle(CLASSNAME_HIDDEN, true);
};

/**
 * Export updateGlasfaserRegistrationForm
 *
 * @export updateGlasfaserRegistrationForm
 */
export const updateGlasfaserRegistrationForm = (newState) => {
    if (newState.initRegistrationForm) {
        initialFormView();
    }

    if (newState.error) {
        showServiceNotAvailableNotification();
    }

    if ('ok' === newState.responseData) {
        showSuccessNotification();
    }
};
